import { PEQuestionnaire } from '../../../../../lib/Questionnaires'
import {
  RadioGroupInput,
  CheckboxInput,
  TextInput
} from '../../../../shared/FormBuilder'

function Respiratory () {
  return (
    <div className='form-section'>
      <div className='row'>
        <div className='col-xs-offset-1 col-xs-4 nh-sub-head'>Normal</div>
        <div className='col-xs-6 nh-sub-head'>Abnormal</div>
      </div>
      <div className='row start-xs'>
        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.respiratoryWheezing.name}
            options={[
              {
                label: 'No Wheezing',
                value: 'No Wheezing'
              },
              {
                label: 'Wheezing',
                value: 'Wheezing'
              }
            ]}
          />
        </div>

        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.respiratoryCrackles.name}
            options={[
              {
                label: 'No Crackles',
                value: 'No Crackles'
              },
              {
                label: 'Crackles',
                value: 'Crackles'
              }
            ]}
          />
        </div>

        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.respiratoryMovement.name}
            options={[
              {
                label: 'Good Movement',
                value: 'Good Movement'
              },
              {
                label: 'Decreased Movement',
                value: 'Decreased Movement'
              }
            ]}
          />
        </div>
        <div className='col-xs-12 margin-top'>
          <CheckboxInput {...PEQuestionnaire.respiratoryOther} />
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-12'>
          <TextInput {...PEQuestionnaire.respiratoryOtherText} />
        </div>
      </div>
    </div>
  )
}

export default Respiratory
